import { useMenuStore } from '@/store';
import { matchRoute, cached } from '@/utils/utils';
// 增加缓存
const PermissionCached = cached(matchRoute);
const InAllRouteCached = cached(matchRoute);

let routeFlattenObjectCache = {};
let routeAllFlattenObjectCache = {};
/**
 * 根据路径获取权限信息
 * @param _path
 * @returns {{route: *, routeAllFlattenObject, isPermission: boolean, isNoPermission: boolean}}
 */
export const getPermissionInfo = (_path) => {
  const menuStore = useMenuStore();
  const { routeAllFlattenObject, routeFlattenObject } = menuStore;
  routeAllFlattenObjectCache = routeAllFlattenObject;
  routeFlattenObjectCache = routeFlattenObject;
  const isPermission = PermissionCached(_path, routeFlattenObject, true);
  const isInAllRoute = InAllRouteCached(_path, routeAllFlattenObjectCache, true);
  return {
    routeAllFlattenObject: routeAllFlattenObject.value,
    route: isInAllRoute, // 路由信息
    // 精确匹配的无无权限页面。
    isPermission: !!isPermission, // 有权限
    isNoPermission: !isPermission && !!isInAllRoute, // 确定为无权限
    // isNotFond: !(isPermission && isInAllRoute), // 找不到
  };
};
